var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g({tag:"component",class:_vm.className,attrs:{"type":_vm.type,"disabled":_vm.loading || _vm.disabled,"to":_vm.to,"tabindex":"100"}},_vm.$listeners),[(_vm.loading)?_c('div',{staticClass:"btn-loader"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }